import React from "react";
import "./main.scss";
import * as serviceWorker from "./serviceWorker";
import { createRoot } from "react-dom/client";
import { MutatorView } from "./components/views/mutator/MutatorView";

const container = document.getElementById("root");
// @ts-ignore
const root = createRoot(container);
root.render(
    <div className="theme-dark" style={{ height: "100%" }}>
        <MutatorView />
    </div>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
